import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Login } from 'src/modules/security/actions/auth-actions';
import { AuthService } from 'src/modules/security/services/auth.service';
import { filter, Observable, take } from 'rxjs';
import { AccountWelcomeState, AppSettingsState } from 'src/states';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppFontSize } from 'src/app/enums/app-font-size.enum';
import { FontControlService } from 'src/core/services/font-control.service';
import { environment } from 'src/environments/environment';
import { PostMessageReceived } from 'src/app/states/post-message/post-message.actions';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class AppInitializerService {
  private readonly authService: AuthService = inject(AuthService);
  private readonly store: Store = inject(Store);
  private readonly fontControlService: FontControlService = inject(FontControlService);

  @Select(AccountWelcomeState.loggingOut)
  private loggingOut$!: Observable<boolean>;

  @Select(AppSettingsState.fontSize)
  private appFontSize$!: Observable<AppFontSize | null>;

  public init(): void {
    const token = this.authService.getToken();

    if (token) {
      this.loggingOut$
        .pipe(
          untilDestroyed(this),
          take(1),
          filter(loggingOut => !loggingOut)
        )
        .subscribe(() => this.store.dispatch(new Login(token)));
    }

    this.appFontSize$.subscribe(updatedAppFontSize => {
      const appFontSize = updatedAppFontSize ?? AppFontSize.MEDIUM;

      this.fontControlService.setAppFontSizeClass(appFontSize);
    });

    window.addEventListener('message', (event): void => {
      if (event.origin !== environment.apiUrl) {
        return;
      }

      this.store.dispatch(new PostMessageReceived(event.data));
    });
  }
}
